import { orpc } from '@/api/rpc/client';
import { ProductModule } from '@erp/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useGetModuleConfigs(options?: {
  /**
   * Pass `'always'` from an editor that must not open on a cached snapshot —
   * writing back what the cache held would undo whatever has been saved since.
   */
  refetchOnMount?: boolean | 'always';
}) {
  return useQuery({
    ...orpc.org.config.modules.getModuleConfigs.queryOptions(),
    ...options,
  });
}

export function useGetModuleConfig(
  module: ProductModule,
  enabled: boolean = true,
) {
  return useQuery({
    ...orpc.org.config.modules.getModuleConfig.queryOptions({
      input: { module },
    }),
    enabled,
  });
}

export function useCreateOrUpdateModuleConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.org.config.modules.createOrUpdateModuleConfig.mutationOptions(),
    onSuccess: () => {
      // Invalidate all module config queries (both list and individual)
      queryClient.invalidateQueries({
        queryKey:
          orpc.org.config.modules.getModuleConfigs.queryOptions().queryKey,
      });
    },
  });
}
